<template lang="html">
    <div class="popup-catalog" :show="show">
        <a @click="show= false" class="cerrar">✕</a>
        <h2><strong>¡Nuevo</strong> catálogo!</h2>
        <h2><strong>New</strong> Catalog!</h2>
        <router-link @click.native="sendEvent,show= false" class="link" :to="`${$t('enlaces.contacto')}/#catalogo`">Solicitar | Request</router-link>
        <img src="/static/img/catalogo-popup@2x.webp" class="img-catalogo" :alt="$t('catalogo.alt_images.catalog')" width="422" height="308" loading="lazy">
    </div>
</template>

<script lang="js">
  import {mapGetters, mapActions} from 'vuex'
    export default  {
      name: 'banner-catalogo',
      mounted() {
        setTimeout(e => {
            if(!!!window.sessionStorage.getItem('_showBanner')){
                this.show = true;
                window.sessionStorage.setItem('_showBanner',true);
            }
        }, 1000)
      },
      data() {
        return{
          show : false
        }
      },
      methods : {
          sendEvent(){
            this.$ga.event({
        eventCategory: 'popup',
        eventAction: 'clic',
        eventLabel: 'catalogo',
        eventValue: 0,
        

      })
          }
      }
    }
  </script>
<style scoped>

    .popup-catalog{
        background: rgba(255, 255, 255, 0.71);
        position: fixed;
        left: -600px;
        bottom: 50px;
        max-width: 360px;
        width: 100%;
        z-index: 10;
        padding: 15px;
        padding-top: 60px;
        transition: .5s;
        transition-timing-function: ease-in-out;
    }

    .popup-catalog[show=true]{
        transform: translateX(600px);
    }

    .popup-catalog .cerrar{
        position: absolute;
        left: 15px;
        top: 5px;
        font-size: 15px;
    }

    .popup-catalog h2{
        text-transform: uppercase;
        font-weight: 300;
        color:#114a7b;
    }

    .popup-catalog h2 strong{
        font-family: "HalisGR-Book";
    }

    .popup-catalog .link{
        text-transform: uppercase;
        color:white;
        background: #e6238f;
        box-shadow: 1px 1px 2.5px 0 #5d378c;
        border-radius: 2px;
        font-size: 12px;
        margin-top: 20px;
        display: inline-block;
        padding: 5px 15px;
        transition: .5s;
    }

    .popup-catalog .link:hover{
        box-shadow: 1px 1px 1.5px 0 #9681af;
    }

    .img-catalogo{
        position: absolute;
        right: -40px;
        top: -130px;
        max-width: 300px;
    }
    

    @media screen and (max-width: 500px){
        .img-catalogo{
        right: -10px;
        top: -130px;
        max-width: 280px;
        pointer-events: none;
    }
    
    }
  </style>


// WEBPACK FOOTER //
// src/components/parts/banner-catalogo.vue